export default __webpack_public_path__ + "static/media/waitrose-partner.d3c28d26.png";